<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{ 'Mutual-Funds History' }}</strong>
        </div>
        <div class="col-md-2">
          <download :tableId="'mf-history'" :fileName="'mf-history'" fromExtFile="true" :downloadParam="collectedParam">
          </download>
        </div>
      </div>
    </div>
    <vue-tabs v-model="selTab" direction="horizontal" @tab-change="getTabData" class="mt-3 ml-3">
      <!-- TAB-1 -->
      <v-tab :title="'Mutual-Funds History'">
        <div class="card-body" v-if="selTab === 'Mutual-Funds History'">
          <div class="row">

            <div class="col-md-4">
              <div class="form-group">
                <v-select :options="schemeList" :placeholder="'Select Scheme'" :label="'name'" v-model="selScheme"
                  @input="getScheme">
                </v-select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group ">
                <v-select :options="scheme_class_codes" :placeholder="'Select Scheme Type'" :label="'name'" class="dropdown-cs"
                  v-model="selSchemeClass" @input="getSchemeClassCode">
                </v-select>
              </div>
            </div>

            <div class="col-md-2">
              <!-- <datepicker :input-class="'form-control input-cs'" :format="'dd-MM-yyyy'" placeholder="Select Date" v-model="ddate"
                @selected="getSelDate($event)"></datepicker> -->
              <div class="form-group new-date">
                <v-select :options="durDateList" :placeholder="'Select Date'" v-model="ddate"
                  @input="getSelDate($event)"></v-select>
              </div>
            </div>
            <div class="col-md-3 d-flex">
              <div class="mr-md-3">
                <div class="form-group">
                  <button class="btn btn-primary" @click="filterSchemes">Filter</button>
                </div>
              </div>
              <div class="">
                <div class="form-group">
                  <button class="btn btn-default" @click="resetFilter">Reset</button>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="table-responsive app">
              <table id="mf-history" class="table table-sm first-td-padding table-bordered app-inner fonts11">
                <thead>
                  <tr>
                    <th style="vertical-align:middle;">Sr.</th>
                    <th style="vertical-align:middle;" v-for="field in tableFields" v-bind:key="'field' + field.title">
                      {{ field.title }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in fillableData" v-bind:key="'row' + index">
                    <td>{{ index + 1 }}</td>
                    <td style="width: 50%;">
                      <div class="company-wrapper">
                        <div class="comapny-child1">
                          <b>Scheme Name: </b><span>{{ row.sch_name }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>ISIN: </b><span>{{ row.isin }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>MF CoCode: </b><span>{{ row.mf_cocode }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>Category: </b><span>{{ row.Category }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>Investment Type: </b><span>{{ row.InvestmentType }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>Fund Type: </b><span>{{ row.FundType }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>Query Question: </b><span>{{ row.query_question }}</span>
                        </div>
                        <div class="comapny-child1">
                          <b>Created At: </b><span>{{ row.created_at }}</span>
                        </div>
                        <div class="comapny-child2 history-col">
                          <b>History: </b><span>{{ row.history }}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div>
                        <vue-ckeditor :id="`history-ck${index}`" v-model="fillableData[index].analytics_history"
                          :config="config" @blur="onBlur($event)" @focus="onFocus($event)"
                          @contentDom="onContentDom($event)" @dialogDefinition="onDialogDefinition($event)"
                          @fileUploadRequest="onFileUploadRequest($event)"
                          @fileUploadResponse="onFileUploadResponse($event)" />
                      </div>
                      <div style="display: flex;justify-content: flex-end;margin-top: 8px;">
                        <button type="button" @click="saveHistory(index)" class="btn btn-sm mb5 btn-primary"
                          style="padding: 0.2rem;">Save</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="fillableData.length == 0">
                  <tr>
                    <td :colspan="(tableFields.length)">
                      <i class="fa fa-info cwhite"></i> No data found.
                    </td>
                  </tr>
                </tfoot>
              </table>
              <!-- <div class="pull-right" v-if="searchParams.sectorname == '' && searchParams.companyname == ''"> -->
              <div class="pull-right">
                <ul v-if="this.totalPages != 1" class="pagination">
                  <li :class="{ disabled: prevDisabled }" class="page-item">
                    <a class="page-link" @click.prevent="goToPage(1)" href="#">{{ '&lt;&lt;' }}</a>
                  </li>
                  <li :class="{ disabled: prevDisabled }" class="page-item">
                    <a class="page-link" @click.prevent="prev()" href="#">{{ '&lt;' }}</a>
                  </li>
                  <li v-for="page in pages" v-bind:key="page" class="page-item"
                    :class="(current_page == page) ? 'active' : ''">
                    <a class="page-link" @click.prevent="goToPage(page)" href="#">{{ page }}</a>
                  </li>
                  <li :class="{ disabled: nextDisabled }" class="page-item">
                    <a class="page-link" href="#" @click.prevent="next()">{{ '&gt;' }}</a>
                  </li>
                  <li :class="{ disabled: nextDisabled }" class="page-item">
                    <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">{{ '&gt;&gt;' }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <PinCheck :show.sync="show" ref="smallModal" v-bind:small="true" @submitForm="submitForm"
          :cancelClass="'btn btn-secondary'"></PinCheck>
      </v-tab>
      <!-- TAB-2 -->
      <v-tab :title="'Mutual-Funds Query'">
        <div class="mb-5" v-if="selTab === 'Mutual-Funds Query'">
          <div style="margin-top: 20px; margin-left: 5px;">
            <div class="col-md-6">
              <div class="form-group">
                <v-select :options="schemeList" :placeholder="'MF Schemes'" :label="'name'" v-model="selScheme"
                  @input="getMFCompRawData">
                </v-select>
              </div>
            </div>
          </div>
          <form class="form-horizontal" style="margin-left: 5px;">
            <div class="form-group row" style="display: contents;">
              <label for="stock-query-txt" class="col-sm-2 col-form-label">Mutual-Funds Query</label>
              <div class="col-sm-12">
                <textarea name="textarea-input" v-model="newQueryData.query_question" id="stock-query-txt" rows="6"
                  placeholder="" class="form-control"></textarea>
              </div>
            </div>
          </form>
          <div style="display: flex;justify-content: center;margin-top: 8px;">
            <button type="button" @click="mfQuerySubmit" class="btn btn-sm mb5 btn-primary"
              style="padding: 0.2rem;">Submit</button>
          </div>
        </div>
      </v-tab>
      <v-tab :title="'Cron Query'">
        <div class="mb-5" v-if="selTab === 'Cron Query'">
          <form class="form-horizontal" style="margin-left: 5px;">

            <div style="display: flex;justify-content: center;margin-top: 8px;">
              <button type="button" @click="showNewQuery" class="btn btn-sm mb5 btn-primary"
                style="padding: 0.2rem;">New Query</button>
            </div>
            <div v-if="isShow" class="d-flex flex-row border p-2 mb-4" style="background-color: #abe5f0;">
              <label for="stock-query-txt" class="col-form-label mr-2">{{ isNew ? "New:" : "Edit:" }}</label>
              <textarea v-model="editCronQueryData.query_question" name="textarea-input" id="stock-query-txt" rows="3"
                placeholder="" class="form-control col-sm-10"></textarea>
              <div class="d-flex align-items-center mr-3 ml-2">
                <label for="is-used" class="m-0">Is Used: <input type="checkbox" v-model="editCronQueryData.is_used"
                    name="is-used" style="width: auto;"></label>
              </div>
              <div class="d-flex align-items-center mr-3">
                <button type="button" @click="cronQuerySubmit" class="btn btn-sm mb5 btn-primary"
                  style="padding: 0.2rem;">Submit</button>
              </div>
            </div>
            <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
            <div class="form-group row cron-query-content">
              <br />
              <div class="d-flex flex-row border p-2 mb-4" v-for="(field, index) in cronQueryDataList"
                style="background-color: #e3e9ac;">
                <textarea :key="`cmp${index}`" name="textarea-input" v-model="field.query_question" rows="3"
                  placeholder="" class="form-control col-sm-10" style="background-color: #ffffff;" readonly></textarea>
                <div class="d-flex align-items-center mr-3 ml-2">
                  <label v-if="field.is_used" for="current-used" class="m-0">Current Used: <input type="radio" readonly
                      :checked="field.is_used" name="current-used" style="width: auto;"></label>
                </div>
                <div class="d-flex align-items-center mr-3">
                  <a class="btn btn-sm btn-small btn-primary" @click.prevent="editQuery(field)">
                    <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </v-tab>
    </vue-tabs>

  </div>
</template>

<script>
import vtable from "@/components/vtable";
import http from "@/lib/http";
import VueJwtDecode from 'vue-jwt-decode'
import VueCkeditor from "vue-ckeditor2";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import PinCheck from "@/components/PinCheck.vue";
import configURL from '@/lib/config';

export default {
  name: "mf-history",
  components: {
    vtable,
    VueCkeditor,
    Datepicker,
    PinCheck
  },
  created() {
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    console.log(this.url.indexOf("mf-history"), this.$route.query);
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "1");
    this.url += "/page/" + this.pageToLoad;
    this.current_page = this.pageToLoad;
    console.log("this.searchParams", this.searchParams);

    /* if (localStorage.getItem('schemeC')) {
      this.searchParams.scheme_name = localStorage.getItem('schemeC');
    };
    if (localStorage.getItem('scheme_typeC')) {
      this.searchParams.category = localStorage.getItem('scheme_typeC');
    }; */

    this.getSchemesList();
    this.getSChemeClassCodes();
    this.fetchData(this.searchParams);
    this.getStockHistoryDate();
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      //apiUrl: "companiesListing/page/",
      apiUrl: "get/schemes-history",
      apiMode: true,
      show: false,
      company: {},
      category: "",
      schemeList: [],
      durDateList: [],
      selScheme: null,
      scheme_class_codes: [],
      selSchemeClass: null,
      collectedParam: "",
      selTab: "",
      isNew: false,
      isShow: false,
      isFromMFQuery: false,
      newQueryData: { mf_schcode: "", query_question: "" },
      editCronQueryData: { query_question: "", is_used: false },
      companyList: [],
      cronQueryDataList: [],
      tableFields: [
        {
          name: "details",
          title: "MF SCHEME DETAILS"
        },
        {
          name: "edit_history",
          title: "Edit History"
        },
      ],
      // itemsPerPage: ItemsPerPageDef.itemsPerPage,
      // sortFunctions: FieldsDef.sortFunctions,
      selectedRowCompanyData: {},
      paginationPath: "",
      searchParams: { "scheme_name": "", "category": "", "selectdate": "" },
      sectorData: [],
      fillableData: [],
      scheme_name: "",
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      config: {
        toolbar: [
          {
            name: "snddocument",
            items: [
              "Source",
              "-",
              "Save",
              "NewPage",
              "DocProps",
              "Preview",
              "Print",
              "-",
              "Templates"
            ]
          },
          { name: "clipboard", items: ["Undo", "Redo"] },
          {
            name: "editing",
            items: [
              "Find",
              "Replace",
              "-",
              "SelectAll",
              "-",
              "SpellChecker",
              "Scayt"
            ]
          },
          {
            name: "forms",
            items: [
              "Form",
              "Checkbox",
              "Radio",
              "TextField",
              "Textarea",
              "Select",
              "Button",
              "ImageButton",
              "HiddenField"
            ]
          },
          "/",
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "RemoveFormat"
            ]
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl"
            ]
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              // "Flash",
              "Table",
              "HorizontalRule",
              "Smiley",
              "SpecialChar",
              "PageBreak",
              "Iframe"
            ]
          },
          { name: "styles", items: ["Styles", "Format", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks"] }
        ]
      },
      ddate: ""
    };
  },
  methods: {
    onBlur(evt) {
      //console.log(evt);
    },
    onFocus(evt) {
      //console.log(evt);
    },
    onContentDom(evt) {
      //console.log(evt);
    },
    onDialogDefinition(evt) {
      //console.log(evt);
    },
    onFileUploadRequest(evt) {
      //console.log(evt);
    },
    onFileUploadResponse(evt) {
      //console.log(evt);
    },
    getTabData(tabIndex, newTab, oldTab) {
      this.selTab = newTab.title;
      console.log('TAB: ', tabIndex, newTab)
      if (tabIndex === 0) {
        this.editCronQueryData = { query_question: "", is_used: false };
        this.newQueryData = { mf_schcode: "", query_question: "" };
        this.isNew = false;
        this.isShow = false;
        this.cronQueryDataList = [];
        this.getStockHistoryDate();
      } else if (tabIndex === 1) {
        this.editCronQueryData = { query_question: "", is_used: false };
        this.newQueryData = { mf_schcode: "", query_question: "" };
        this.isNew = false;
        this.isShow = false;
        this.cronQueryDataList = [];
        this.isFromMFQuery = false;
        //this.getStockHistoryDate();
        //this.getSchemesList();
      } else if (tabIndex === 2) {
        this.newQueryData = { mf_schcode: "", query_question: "" };
        this.editCronQueryData = { query_question: "", is_used: false };
        this.isNew = false;
        this.isShow = false;
        this.isFromMFQuery = false;
        this.cronQueryDataList = [];
        this.getMFHistoryCronQuery();
      }
    },
    mfQuerySubmit() {
      //console.log('=> Stock Query Submit', this.newQueryData, this.selScheme);
      console.log('=> MF Query Submit', this.newQueryData, this.selScheme);

      let _this = this;

      this.newQueryData.mf_schcode = this.selScheme.id;

      if (_this.newQueryData.mf_schcode.length === 0) {
        this.$toastr.error("Please Select Company", "", {});
        return;
      }

      if (this.newQueryData.query_question.length === 0) {
        this.$toastr.error("Query string not blank", "", {});
      } else {
        //return;
        http.post("gemini/frontend/insertMutualDetailsFromAi", this.newQueryData, function (error, response) {
          if (response.success === "success") {
            _this.isFromMFQuery = true;
            _this.$toastr.success(response.message, "", {});
            _this.selTab = "Mutual-Funds History";

            _this.fetchData(_this.searchParams);
          }
        });
      }
    },
    cronQuerySubmit() {
      console.log('Cron Query Submit', this.editCronQueryData);
      let _this = this;
      if (this.editCronQueryData.query_question.trim() === "") {
        this.$toastr.error("Query string not blank", "", {});
      } else {
        http.post("update_or_insert/mf_history_cron_query_question", this.editCronQueryData, function (error, response) {
          if (response.status === "success") {
            _this.$toastr.success(response.message, "", {});
            _this.getMFHistoryCronQuery();
            _this.editCronQueryData = { query_question: "", is_used: false };
            _this.isNew = false;
            _this.isShow = false;
          }
        });
      }
    },
    getMFHistoryCronQuery() {
      let _this = this;
      http.get("get/mf_history_cron_query_question", {}, function (error, response) {
        if (response.status === "success") {
          _this.cronQueryDataList = response.data;
        }
      });
    },
    getStockHistoryDate(param) {
      //https://api.nobiasinvesting.com/frontend/filter-date?collection_name=stock-history
      //https://api.nobiasinvesting.com/mutual-funds/filter-date?collection_name=mutualfund-history&scheme_code=44358
      console.log('param >>>', param);
      let extParam = "";
      if(param != undefined){
        extParam = "&scheme_code="+param.id;
      }

      let apiUrl = "frontend/filter-date?collection_name=mutualfund-history"+extParam;

      http.get(apiUrl, {}, (error, response) => {
        //console.log("date response: ", response);
        if (response.responseType === 'success') {
          this.durDateList = response.date;
        }
      });
    },
    editQuery(param) {
      this.editCronQueryData = param;
      this.isNew = false;
      this.isShow = true;
      //console.log("editQuery param", param);
    },
    showNewQuery() {
      this.editCronQueryData = { query_question: "", is_used: false };
      this.isNew = true;
      this.isShow = true;
    },
    getMFCompRawData() {
      //console.log("Get RawData", this.selScheme);
      if (this.selScheme !== null) {
        this.newQueryData.mf_schcode = this.selScheme.id;
      } else {
        this.newQueryData.mf_schcode = "";
      }
    },
    getSchemesList() {
      let _this = this;
      http.get("mutual-funds/schemes?onlyCodeAndNames=1", {}, function (error, response) {
        if (response.status == 'success') {
          var schemeList = response.data;
          _this.schemeList = [];
          if (schemeList.length > 0) {
            schemeList.forEach((scheme) => {
              _this.schemeList.push({ id: scheme.mf_schcode, name: scheme.sch_name });
            });
            /* _this.schemeList = _this.sorted_fields_asc(
              _this.schemeList,
              "id"
            ); */
          }
        }
      });
    },
    getSChemeClassCodes() {
      let _this = this;
      http.get("mutual-funds/scheme-class-codes", {}, function (error, response) {
        if (response.status == 'success') {
          var scheme_class_codes = response.data;
          _this.scheme_class_codes = [];
          if (scheme_class_codes.length > 0) {
            /* if(_this.rawDataType == 'scheme-return-ranks') {
              _this.selSchemeClass = {id: scheme_class_codes[0].classcode, name: scheme_class_codes[0].typename};
              _this.getRawData();
            } */
            scheme_class_codes.forEach((scheme) => {
              _this.scheme_class_codes.push({ id: scheme.classcode, name: scheme.typename });
            });
          }
          //console.log('_this.scheme_class_codes length', _this.scheme_class_codes.length);
        }
      });
    },
    getScheme() {
      //console.log('getScheme called', this.selScheme);
      if (this.selScheme) {
        this.scheme_name = this.selScheme.name;
        /* if(this.rawDataType != 'scheme-ratios' && this.rawDataType != 'scheme-asset-allocation' && this.rawDataType != 'avg-maturity-data'  && this.rawDataType != 'scheme-return-ranks') {
          this.filterSchemes();
        } */

      } else {
        this.scheme_name = '';
        // console.log(this.selScheme);
        /* if(this.rawDataType != 'scheme-ratios' && this.rawDataType != 'scheme-asset-allocation'  && this.rawDataType != 'avg-maturity-data' && this.rawDataType != 'scheme-return-ranks') {
          this.filterSchemes();
        } */
      }
      this.getStockHistoryDate(this.selScheme);
      
    },
    getSchemeClassCode() {
      //console.log('getSchemeClassCode', this.selSchemeClass);
      /* if(this.selSchemeClass) {
        this.scheme_class = this.selSchemeClass.id
        this.schemeClassCode = this.selSchemeClass.id;
      } else {
        this.scheme_class = ''
        this.schemeClassCode = '';
      }
      if( this.rawDataType != 'scheme-returns' && this.rawDataType != 'avg-maturity-data' && this.rawDataType != 'scheme-ratios' && this.rawDataType != 'scheme-asset-allocation' && this.rawDataType != 'scheme-return-ranks') {
        this.getRawData();
      } */
    },
    filterSchemes() {
      //console.log(">>> scheme_name:", this.scheme_name, "| selScheme:", this.selScheme, "| selSchemeClass:", this.selSchemeClass, "| ddate:", this.ddate);
      /* if(this..length > 1 || this.selFundManager != null || this.category.length > 1 || this.searchText.length > 1
         || this.searchP11.min.length > 1  || this.searchp11qtr.min.length > 1  || this.searchq1ab.min.length > 1  || this.searchPortfolioRating.min.length > 1
         || this.searchP11.max.length > 1  || this.searchp11qtr.max.length > 1  || this.searchq1ab.max.length > 1  || this.searchPortfolioRating.max.length > 1) {
        this.search();
        console.log('Search');
      } else {
        this.rawData = this.searchData;
      } */
      this.searchParams = { "scheme_name": this.selScheme ? this.selScheme.name : "", "category": this.selSchemeClass ? this.selSchemeClass.name : "", "selectdate": this.ddate };

      /* if (this.searchParams.scheme_name !== null || this.searchParams.scheme_name !== "") {
        localStorage.setItem('schemeC', this.searchParams.scheme);
      }

      if (this.searchParams.category !== null || this.searchParams.category !== "") {
        localStorage.setItem('scheme_typeC', this.searchParams.category);
      } */

      let paramSchemeName = "";
      let paramCategory = "";
      let paramSelDate = "";
      if (this.searchParams.scheme_name.length !== 0) {
        paramSchemeName = `&scheme_name=${this.searchParams.scheme_name}`;
      }
      if (this.searchParams.category.length !== 0) {
        paramCategory = `&category=${this.searchParams.category}`;
      }
      //console.log('this.ddate=>>', this.ddate)
      if (this.ddate !== null && this.ddate !== "") {
        paramSelDate = `&selectdate=${this.ddate}`;

      }
      this.collectedParam = paramSchemeName + paramCategory + paramSelDate;
      //console.log('this.collectedParam =>>>', this.collectedParam)


      this.fetchData(this.searchParams);
    },
    resetFilter() {

      this.searchParams = { "scheme_name": "", "category": "", "selectdate": "" };
      this.selScheme = null;
      this.selSchemeClass = null;
      this.ddate = "";

      this.collectedParam = "";
      /* if (this.searchParams.scheme_name !== null || this.searchParams.scheme_name !== "") {
        localStorage.setItem('schemeC', this.searchParams.scheme);
      }

      if (this.searchParams.category !== null || this.searchParams.category !== "") {
        localStorage.setItem('scheme_typeC', this.searchParams.category);
      } */
      this.fetchData(this.searchParams);

    },
    viewCalculatedData(row) {
      localStorage.setItem("selcomp", JSON.stringify({ companyname: row.companyname, co_code: row.co_code }));
      this.$router.push({ name: "calculateddata", params: { company: row } });
      //`rawdata/${row}`
    },
    viewRawData(row) {
      this.$router.push({ name: "rawdata", params: { company: row } });
      //`rawdata/${row}`
    },
    getSelDate(e) {
      console.log("Selected date", e);
      this.ddate = e;
      //this.getRawData();
    },
    saveHistory(e) {
      //console.log("save history: ", e);
      this.selectedRowCompanyData = this.fillableData[e];
      //console.log("Row Compnay Data: ", this.selectedRowCompanyData);

      this.$refs.smallModal.open();
      //this.submitForm();
    },
    submitForm() {
      // this.validatePin(pin);
      console.log("selectedRowCompanyData: ", this.selectedRowCompanyData);
      /* "scheme_code":110,
      "comment":"this is test comment" */
      const data = {
        scheme_code: this.selectedRowCompanyData.mf_schcode,
        comment: this.selectedRowCompanyData.analytics_history
      };
      console.log("mf submit data: ", data);
      let _this = this;
      http.post("mutual-fund-GeneralComments/update", data, (error, response) => {
        console.log("Response", response);
        if (response.responseType === "success") {
          _this.$toastr.success("Updated Successfully!", "", {});
        } else {
          _this.$toastr.error("Error", "", {});
        }
        _this.submitAnalyticsHistory();
      });
    },
    submitAnalyticsHistory() {
      console.log("submitAnalyticsHistory=> ", this.selectedRowCompanyData);
      //return;
      http.post("update/schemes-history", this.selectedRowCompanyData, (error, response) => {
        console.log("Response", response);
        if (response.status === "success") {
          this.$toastr.success("Updated Successfully!", "", {});
        } else {
          this.$toastr.error("Error", "", {});
        }
      });
    },
    search() {
      console.log("searchParams: >>> ", this.searchParams);
      /*  if (
         this.searchParams.companyname.length > 2 ||
         this.searchParams.sectorname != ""
       ) {
         if (this.searchParams.sectorname != "") {
           localStorage.setItem('secC', this.searchParams.sectorname);
         }
         this.fetchData(this.searchParams);
       }
       if (
         this.searchParams.companyname.length == 0 &&
         this.searchParams.sectorname == ""
       ) {
         console.log("Reset");
         this.reset();
       } else {
         console.log("Not Reset");
       } */
      // this.$refs.search.searchIn(this.searchParams);
    },
    getSectorData() {
      let _this = this;
      // this.axios.get("getSectorList", {}, {headers: {Authorization: 'Bearer ' + localStorage.getItem('token')}}).then((response) => {
      http.get("getSectorList", {}, function (error, response) {
        //console.log("> Sector Data", response);
        _this.sectorData = response;
      });
      this.sectorData = [
        {
          "sect_name": "Agro Chemicals",
          "sect_code": "00000001"
        },
        {
          "sect_name": "Automobile",
          "sect_code": "00000005"
        },
        {
          "sect_name": "Banks",
          "sect_code": "00000006"
        },
        {
          "sect_name": "Cement",
          "sect_code": "00000011"
        },
        {
          "sect_name": "Cement - Products",
          "sect_code": "00000012"
        },
        {
          "sect_name": "Ceramic Products",
          "sect_code": "00000013"
        },
        {
          "sect_name": "Chemicals",
          "sect_code": "00000014"
        },
        {
          "sect_name": "ETF",
          "sect_code": "00000069"
        },
        {
          "sect_name": "Fertilizers",
          "sect_code": "00000025"
        },
        {
          "sect_name": "Finance",
          "sect_code": "00000026"
        },
        {
          "sect_name": "FMCG",
          "sect_code": "00000027"
        },
        {
          "sect_name": "Paints/Varnish",
          "sect_code": "00000043"
        },
        {
          "sect_name": "Petrochemicals",
          "sect_code": "00000045"
        },
        {
          "sect_name": "Pharmaceuticals",
          "sect_code": "00000046"
        },
      ];
    },
    reset() {
      // window.location.reload();
      //this.$router.push({ name: "stock-history" });
      localStorage.removeItem('secC');
      this.searchParams = { "scheme_name": "", "category": "", "selectdate": "" },
        this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl + "/page/" + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        /* console.log("data=====");
        console.log(data);
        console.log("=====data");
        console.log("===== | " + this.url + " | " + this.pageToLoad + " | " + this.current_page + " | " + this.pages + " ========"); */
        let myself = this;

        //{"scheme_name": "", "category": "", "selectdate": ""},
        //console.log("=> Date: ", myself.ddate, moment(data.selectdate).format('DD-MM-YYYY'));
        //let sDate = data.selectdate !== "" ? moment(data.selectdate).format('DD-MM-YYYY') : "";
        let sDate = myself.ddate == null ? "" : myself.ddate;
        if (this.isFromMFQuery) {
          data.scheme_name = this.selScheme.name;
          this.isFromMFQuery = false;
        }

        let paramsInline = data ? `scheme_name=${(data.scheme_name).trim()}&category=${(data.category).trim()}&selectdate=${(sDate)}` : "";
        //console.log("> paramsInline: ", paramsInline);
        //return;

        http.get(this.url + "?" + paramsInline, {}, function (error, response) {
          //  this.axios.post(this.url, params,  {headers: {Authorization: 'Bearer ' + localStorage.getItem('token')}}).then((response) => {
          //console.log(response);
          if (!error) {

            const filteredStockHistoryData = response.data.map(function (keyData) {
              let newKeyData = keyData;
              newKeyData.analytics_history = keyData.analytics_history ? keyData.analytics_history : "";
              return newKeyData;
            });

            //console.log("filteredStockHistoryData >>> ", filteredStockHistoryData);
            myself.fillableData = filteredStockHistoryData;
            myself.current_page = myself.pageToLoad;
            myself.totalPages = response.total_pages;
            myself.prevDisabled = myself.pageToLoad == 1;
            myself.nextDisabled = myself.current_page == myself.totalPages;
            myself.isLoading = false;
            // set 5 pages to show
            console.log("current", myself.current_page);
            let i = 5;
            let page = myself.current_page - 2;
            if (page <= 0) page = 1;
            myself.pages = [];
            while (i) {
              myself.pages.push(parseInt(page));
              if (myself.totalPages <= page) break;
              page++;
              i--;
            }
            myself.getSectorData();
            console.log("PAges", myself.pages);
          } else {
            console.log(error);
          }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += "/page/" + this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}


.company-wrapper {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.company-chidl1 {
  width: 50%;
}

.company-chidl2 {
  width: 100%;
}

.form-control[readonly] {
  background-color: unset;
}

.input-cs {
  font-size: 1em;
  height: 34px;
}

.new-date .selected-tag {
  position: absolute;
}

.cron-query-content {
  display: grid;
  overflow-y: scroll;
}
.dropdown-cs > input{
  width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/views/mutual-funds/reports/mf-history.vue